import angular from 'angular';
import onboardingEntityDetails from './onboardingEntityDetails';

export default angular
  .module('components.onboardingEntityDetails', [])
  .component('onboardingEntityDetails', onboardingEntityDetails).name;
